import { Component, inject, OnInit } from '@angular/core';
import { IonHeader, IonInfiniteScroll, IonInfiniteScrollContent } from '@ionic/angular';
import { IonInfiniteScrollCustomEvent } from '@ionic/core';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { PageComponent } from '@ninety/mobile/platform/components';

import DiscussionListVm from '../../../models/view/discussion-list-container.model';
import { DiscussionListActions } from '../../../state/actions';
import { selectDiscussionListVm } from '../../../state/selectors';
import { DiscussionStateModule } from '../../../state/state';
import { DiscussionEmptyStateComponent } from '../../discussion-empty-state/discussion-empty-state.component';
import { DiscussionToolbarComponent } from '../../discussion-toolbar/discussion-toolbar.component';
import { DiscussionCmTieredComponent } from '../discussion-cm-tiered/discussion-cm-tiered.component';
import { DiscussionListComponent } from '../discussion-list/discussion-list.component';
import { DiscussionListSkeletonLoaderComponent } from '../discussion-list-skeleton-loader/discussion-list-skeleton-loader.component';

@Component({
  selector: 'nty-discussion-list-container',
  imports: [
    IonHeader,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    LetDirective,
    DiscussionCmTieredComponent,
    DiscussionToolbarComponent,
    DiscussionListComponent,
    DiscussionListSkeletonLoaderComponent,
    DiscussionStateModule,
    DiscussionEmptyStateComponent,
    PageComponent,
  ],
  templateUrl: './discussion-list-container.component.html',
  styles: [
    `
      @use 'terra';
    `,
  ],
})
export class DiscussionListContainerComponent implements OnInit {
  private readonly store = inject(Store);

  readonly vm$: Observable<DiscussionListVm> = this.store.select(selectDiscussionListVm);

  ngOnInit(): void {
    this.store.dispatch(DiscussionListActions.discussionListInit());
  }

  onIonInfinite(event: IonInfiniteScrollCustomEvent<unknown>) {
    this.store.dispatch(DiscussionListActions.ionScrollEvent({ event }));
  }

  handleRefresh() {
    this.store.dispatch(DiscussionListActions.discussionRefresh());
  }
}
